import React, { useEffect, useState, useCallback } from 'react'
import { UserRepository } from 'app/shared/data-access/users'
import { useToastContext } from 'app/shared/state/toast-context'
import ResetPasswordView from './set-password-view'
import { useHistory } from 'react-router-dom'
import { useIsBusyContext } from 'app/shared/state/is-busy-context'

const SetPassword = () => {
  const { addToast, toastOnError } = useToastContext()
  const history = useHistory()
  const { isBusy, setIsBusy } = useIsBusyContext()

  const [hasValidParams, setHasValidParams] = useState<boolean | undefined>()

  const params = new URLSearchParams(window.location.search)

  const userId = params.get('userId')
  const token = params.get('token')

  const loadValidity = useCallback(async (userId: string, token: string) => {
    const result = await UserRepository.forgotPassword(false, {
      userId,
      token,
    })

    setHasValidParams(!result.error)
  }, [])

  useEffect(() => {
    if (!userId || !token) {
      setHasValidParams(false)
      return
    }
    loadValidity(userId, token)
  }, [userId, token, loadValidity])

  const onSendResetPassword = async (password: string) => {
    if (!userId || !token) {
      return
    }

    setIsBusy(true)

    const result = toastOnError(
      await UserRepository.forgotPassword(true, {
        userId,
        token,
        newPassword: password,
      })
    )

    if (!result.error) {
      addToast({
        variant: 'success',
        message: 'Uw wachtwoord is aangepast.',
      })
      history.push('/login')
    }

    setIsBusy(false)
  }

  if (hasValidParams === undefined) {
    return <></>
  }

  return <ResetPasswordView isBusy={isBusy} onSendResetPassword={onSendResetPassword} hasValidParams={hasValidParams} />
}

export default SetPassword
